<template>
  <v-app id="app">
    <v-content>
      <!-- <v-container
        class="grey lighten-5"
        style="max-width: 80%; margin-top: 15%; padding: 0; border-radius: 8px"
        v-if="this.path === 'logs'"
      >
        <v-img
          style="margin: auto; margin-top: 120px"
          :src="image"
          width="200"
        ></v-img>
        <v-row>
          <span class="font-weight-black" style="margin: auto"
            >ยินดีต้อนรับ</span
          >
        </v-row>
        <v-row>
          <span style="margin: auto">กรุณารอสักครู่</span>
        </v-row>
        <v-row no-gutters>
          <v-progress-circular
            :width="3"
            style="margin: auto"
            color="red"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </v-container> -->
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import image from "@/assets/Logo.png";
// import logo from "@/assets/Logo.jpg";
export default {
  name: "App",
  data: () => ({
    image: image,
    path: "",
    // logoSizzler: logo
  }),
  async created() {
    // this.path = this.$route.name;
    // console.log(1234);
    // console.log(this.$route.name);
    // this.success();
  },
  watch: {
    // $route(to, from) {
    //   this.success();
    // }
  },
  methods: {
    // success() {
    //   if (
    //     this.$route.path === "/success" &&
    //     this.$store.getters.getMember.active
    //   ) {
    //     this.$swal("สำเร็จ", "ลงทะเบียนเรียบร้อยแล้ว", "success");
    //   }
    // }
  },
};
</script>
<style>
@import "https://fonts.googleapis.com/css?family=Kanit";
#app,
.v-application {
  font-family: "Kanit" !important;
  text-align: left;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center;
  color: #2c3e50; */
}
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px !important;
}
input {
  text-align: -webkit-left !important;
}
.v-date-picker-title__date {
  font-size: 15px !important;
}
.swal-text {
  font-family: "Kanit" !important;
  text-indent: 50px;
  text-align: justify;
  letter-spacing: 1px;
}
.swal-title {
  font-family: "Kanit" !important;
}
[data-role="surface"] {
  margin: auto !important;
}
</style>
